var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"price-container"},[_c('CurrencyNew',{attrs:{"price":_vm.course.price,"priceUnderline":_vm.course.underlined_price,"isUnderlineLeft":false,"priceTwo":""}}),(_vm.course.is_show_discount == 1)?_c('div',{staticClass:"discount"},[_vm._v(_vm._s(_vm.course.discount)+"折优惠")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }